/**
 * Swatch & Size Button Logic
 * Ported from SWATCH_LOGIC.md
 *
 * Handles:
 * 1. Global swatch radio change handler — bridges .swatch :radio to variant-selects web component
 * 2. Size button generation — converts #option-size select into visual .select-button divs
 * 3. Stock management — setStock(), setBIS(), extractIdentifier()
 * 4. Variant price display — updates visible price when color/size changes
 */

(function ($) {

  // ─── 1. Global swatch radio change handler ───────────────────────────────────
  // When a .swatch :radio changes, find the matching radio inside variant-selects
  // and trigger a change so the web component updates the selected variant.
  $(document).on('change', '.swatch :radio', function () {
    console.log('swatch radio changed', $(this).val());
    console.log('swatch-element clicked', $(this).data('value'));

    var optionIndex = parseInt($(this).closest('.swatch').attr('data-option-index'), 10);
    var optionValue = $(this).val();

    var $productInfo = $(this).closest('[id^="ProductInfo-"]');
    var $variantSelects = $productInfo.find('variant-selects');

    if ($variantSelects.length) {
      // data-index is 1-based ("option1", "option2", ...)
      var $fieldset = $variantSelects.find('[data-index="option' + (optionIndex + 1) + '"]');
      if ($fieldset.length) {
        var $matchingRadio = $fieldset.find('input[type="radio"]').filter(function () {
          return $(this).val() === optionValue;
        });
        if ($matchingRadio.length && !$matchingRadio.is(':checked')) {
          $matchingRadio.prop('checked', true).trigger('change');
        }
      }
    }

    // Direct fallback: for color-only products the original-selector option id is
    // just the PascalCase variant title (e.g. "MulticamAlpine").  Look it up and
    // update the form input directly — this guarantees the right variant ID is set
    // even when variant-selects does not fire (e.g. same color already checked).
    var colorKey = optionValue.split(' ').map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join('');
    var $opt = $productInfo.find('.original-selector').find('#' + colorKey);
    if ($opt.length) {
      var directId = String($opt.val());
      if (directId) {
        $productInfo.find('form[id^="product-form-"] input[name="id"]').each(function () {
          if ($(this).val() !== directId) {
            $(this).val(directId).trigger('change');
          }
        });
      }
    }
  });

  // ─── 2 & 3. Size buttons + Stock management ──────────────────────────────────
  $(document).ready(function () {

    var selectHidden = document.getElementById('option-size');
    var buttonContainer = document.getElementById('buttonContainer');

    if (!selectHidden || !buttonContainer) {
      // No size option — hide the size label if present
      var sizeLabel = document.getElementById('size-label');
      if (sizeLabel) sizeLabel.style.display = 'none';

      // JB: still need swatch → variant-selects sync even on non-size products
      $(document).on('click', '.swatch-element', function () {
        var value = String($(this).data('value') || '');
        if (!value) return;

        // Find and check the matching variant-selects color radio
        $('variant-selects [data-handle="color"] input[type="radio"]').filter(function () {
          return $(this).val() === value;
        }).prop('checked', true).trigger('change');

        // Build lookup key from non-color variant-selects radios + clicked color
        var parts = [];
        $('variant-selects').first().find('fieldset').each(function () {
          if ($(this).attr('data-handle') === 'color') return;
          var $checked = $(this).find('input[type="radio"]:checked, select').first();
          var v = $checked.is('select') ? $checked.val() : $checked.val();
          if (v) parts.push(extractIdentifier(v).replace(/\//g, '_'));
        });
        parts.push(extractIdentifier(value).replace(/\//g, '_'));
        var lookupKey = parts.join('_');
        var variantId = $('.original-selector #' + lookupKey).val();
        if (variantId) {
          $('form[id^="product-form-"] input[name="id"]').each(function () {
            if ($(this).val() !== String(variantId)) $(this).val(variantId).trigger('change');
          });
          updatePriceForVariant(variantId);
          updateUrlVariant(variantId);
        }
      });

      return;
    }

    // Hide the color and size fieldsets inside variant-selects because the
    // custom colorswatchconatiner and buttonContainer replace them visually.
    if ($('.colorswatchconatiner .swatch').length) {
      $('variant-selects [data-handle="color"]').hide();
    }
    $('variant-selects [data-handle="size"]').hide();

    // Track currently selected color (spaces stripped to match variant ID format)
    var selected_color;
    var $firstSwatch = $('.colorswatchconatiner .swatch-element').eq(0);
    if ($firstSwatch.length) {
      selected_color = String($firstSwatch.data('value') || '').replace(/\s/g, '');
    } else {
      // Fallback: read from variant-selects color radio
      var $checkedColor = $('variant-selects [data-handle="color"] input[type="radio"]:checked');
      if ($checkedColor.length) {
        selected_color = $checkedColor.val().replace(/\s/g, '');
      }
    }

    // ── Button click handler ────────────────────────────────────────────────────
    function handleButtonClick(event) {
      console.log('handleButtonClick fired', event.target.getAttribute('data-value'));
      var value = event.target.getAttribute('data-value');

      // Update the hidden #option-size select and fire change
      selectHidden.value = value;
      selectHidden.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));

      // Also sync the variant-selects size fieldset so the form variant ID updates.
      // The fieldset may be rendered as a dropdown <select> or radio buttons depending
      // on the theme's "variant_picker" block setting — handle both cases.
      var $sizeFieldset = $('variant-selects [data-handle="size"]');
      if ($sizeFieldset.length) {
        var $sizeSelect = $sizeFieldset.find('select');
        if ($sizeSelect.length) {
          // Dropdown type — update the select value and fire change so
          // variant-selects.onVariantChange() recalculates the active variant.
          $sizeSelect.val(value).trigger('change');
        } else {
          // Radio button type — check the matching radio and fire change.
          $sizeFieldset.find('input[type="radio"]').filter(function () {
            return $(this).val() === value;
          }).prop('checked', true).trigger('change');
        }
      }

      // Sync the .multi-variantions size fieldset (used on products with a
      // swatch_products link list, where product-redirect-swatch.js handles
      // variant selection instead of variant-selects).  Triggering change on the
      // hidden radio causes variantProduct() to re-run and update input[name="id"].
      var $mvSizeFieldset = $('.multi-variantions .product-form__input').filter(function () {
        return ($(this).attr('data-handle') || '').toLowerCase() === 'size';
      });
      if ($mvSizeFieldset.length) {
        $mvSizeFieldset.find('input[type="radio"]').filter(function () {
          return $(this).val() === value;
        }).prop('checked', true).trigger('change');
      }

      // Update active state
      $('.select-button').removeClass('active');
      event.target.classList.add('active');

      // Directly update the product form variant ID
      updateVariantId();

      // Show / hide BIS button based on stock
      var stock = $(event.target).data('stock');
      $('.BIS_trigger.active').removeClass('show');
      if (stock === 'out') {
        $('.BIS_trigger.active').addClass('show');
      } else if (stock === undefined) {
        $(event.target).attr('data-stock', 'out');
      }
    }

    // ── Generate size buttons from #option-size ─────────────────────────────────
    // Sort alphabetically when the first size value contains two or more digits
    // (handles waist×inseam sizes like "30x32").
    var checkValue = selectHidden.options[0] ? selectHidden.options[0].getAttribute('value') : '';
    var numbersRegex = /\d.*\d/;
    var sortedArray = Array.from(selectHidden.options);

    if (numbersRegex.test(checkValue)) {
      sortedArray = sortedArray.sort(function (a, b) {
        return a.getAttribute('value').localeCompare(b.getAttribute('value'));
      });
    }

    sortedArray.forEach(function (option) {
      var button = document.createElement('div');
      button.textContent = option.textContent;
      button.setAttribute('data-value', option.value);
      button.setAttribute('data-stock', option.getAttribute('data-stock'));
      button.classList.add('select-button');
      button.addEventListener('click', handleButtonClick);
      buttonContainer.appendChild(button);
    });

    // ── Initialize stock on page load ───────────────────────────────────────────
    var first_style = $('#option-style').val();
    setStock(selected_color, extractIdentifier(first_style));

    //JB ── Auto-select first available size on page load ───────────────────────────
    // After stock states are applied, click the first button that isn't disabled/OOS.
    var $firstAvailable = $('#buttonContainer .select-button').not('[disabled]').not('[data-stock="out"]').first();
    if ($firstAvailable.length) {
      $firstAvailable[0].click();
    } else {
      // Fallback: if everything is OOS, at least visually activate the first button
      $('#buttonContainer .select-button').first().addClass('active');
    }
    // ── Color swatch click → re-run setStock + gallery image switch ─────────────
    $(document).on('click', '.swatch-element', function () {
      selected_color = String($(this).data('value') || '').replace(/\s/g, '');
      var handle = $(this).data('handle');
      var style = $('#option-style').val();
      setStock(selected_color, extractIdentifier(style));
      setBIS(handle);
      updateVariantId();

      // Switch the product gallery to this color's featured image.
      // Works for both standard and SellersDash multi-product setups.
      var mediaId = $(this).data('featured-media-id');
      if (mediaId) {
        var sectionId = $('variant-selects').first().data('section');
        var productSlider = document.querySelector('#Product-Slider');
        if (sectionId && productSlider) {
          var slideSelector = '#Slide-' + sectionId + '-' + mediaId;
          // Flickity is bound directly on the element — selectCell is available
          if (typeof productSlider.selectCell === 'function') {
            productSlider.selectCell(slideSelector);
          }
        }
      }
    });

    // Fallback: if no custom swatch, listen to variant-selects color radio changes
    $(document).on('change', 'variant-selects [data-handle="color"] input[type="radio"]', function () {
      if (!$('.colorswatchconatiner .swatch').length) {
        selected_color = $(this).val().replace(/\s/g, '');
        var style = $('#option-style').val();
        setStock(selected_color, extractIdentifier(style));
      }
    });

    // ── setBIS ──────────────────────────────────────────────────────────────────
    // Show the Back-In-Stock button that matches the selected color handle.
    function setBIS(handle) {
      $('.BIS_trigger').each(function () {
        var button_handle = $(this).data('handle');
        if (button_handle && button_handle.indexOf(handle) !== -1) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
      });
    }

    // ── setStock ────────────────────────────────────────────────────────────────
    // For each size button, look up the hidden .original-selector option whose
    // id is "{Style_}Color_Size" and read its data-stock attribute.
    function setStock(color, style) {
      if (!color) return;

      $('#buttonContainer .select-button').each(function () {
        var raw = String($(this).data('value') || '');
        // Replace slashes with underscores to match the variant ID format
        var size = raw.length > 1 ? raw.replace(/\//g, '_') : raw;

        var stock;
        if (style !== undefined) {
          stock = $('#' + style + '_' + color + '_' + size).data('stock');
        } else {
          stock = $('#' + color + '_' + size).data('stock');
        }

        $(this).prop('disabled', false).attr('data-stock', stock);

        if (stock === 'out') {
          $(this).prop('disabled', true);
        } else if (stock === undefined) {
          $(this).attr('data-stock', 'out');
        }
      });
    }

    // ── extractIdentifier ───────────────────────────────────────────────────────
    // Converts "Light Blue" → "LightBlue" (PascalCase, no spaces) to match the
    // variant title ID format generated in the Liquid original-selector.
    function extractIdentifier(text) {
      if (text === undefined || text === null) return undefined;
      return text.split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join('');
    }

    // ── updateVariantId ──────────────────────────────────────────────────────────
    // Looks up the variant ID from the .original-selector options using the same
    // {Style_}Color_Size key as setStock(), then writes it to the product form's
    // input[name="id"].  This is the reliable path for SHSD multi-product setups
    // where variant-selects may not have all option values available.
    function updateVariantId() {
      var sizeRaw = String(selectHidden.value || '');
      if (!sizeRaw) return;

      var size = sizeRaw.length > 1 ? sizeRaw.replace(/\//g, '_') : sizeRaw;
      var style = extractIdentifier($('#option-style').val());

      if (!selected_color) {
        // JB: build lookup key from variant-selects radios when no color swatch is present
        var parts = [];
        $('variant-selects').first().find('fieldset').each(function () {
          if ($(this).attr('data-handle') === 'size') return; // appended separately below
          var $checked = $(this).find('input[type="radio"]:checked, select').first();
          var val = $checked.is('select') ? $checked.val() : $checked.val();
          if (val) parts.push(extractIdentifier(val).replace(/\//g, '_'));
        });
        parts.push(size);
        var lookupKey = parts.join('_');
        var variantId = $('.original-selector #' + lookupKey).val();
        if (!variantId) return;
        $('form[id^="product-form-"] input[name="id"]').each(function () {
          if ($(this).val() !== String(variantId)) {
            $(this).val(variantId).trigger('change');
          }
        });
        updatePriceForVariant(variantId);
        updateUrlVariant(variantId);
        return;
      }

      var variantId;
      if (style !== undefined) {
        variantId = $('#' + style + '_' + selected_color + '_' + size).val();
      } else {
        variantId = $('#' + selected_color + '_' + size).val();
      }

      if (!variantId) return;

      $('form[id^="product-form-"] input[name="id"]').each(function () {
        if ($(this).val() !== String(variantId)) {
          $(this).val(variantId).trigger('change');
        }
      });

      updatePriceForVariant(variantId);
      updateUrlVariant(variantId);
    }

    // ── updatePriceForVariant ───────────────────────────────────────────────────
    // Reads variant data from the ProductData JSON block (injected by
    // main-product.liquid) and updates the visible price element. This is needed
    // because the custom swatch click handler bypasses variant-selects entirely,
    // so VariantSelects.renderProductInfo() never runs to refresh the price.
    function updatePriceForVariant(variantId) {
      var $productData = $('#ShsdProductVariants');
if (!$productData.length) return;

var variants;
try {
  variants = JSON.parse($productData.text());
} catch (e) {
  return;
}

var variant = (variants || []).find(function (v) {
  return String(v.id) === String(variantId);
});

if (!variant) return;

      var formatMoney = function (cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, '${{amount}}');
        }
        return '$' + (cents / 100).toFixed(2);
      };

      var newPrice = formatMoney(variant.price);
      var newCompareAt = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;

      // Update every price container on the page (main + sticky)
      $('[id^="price-template--"]').each(function () {
        var $container = $(this);

        var $priceEl = $container.find('ins .money').first();
        if (!$priceEl.length) $priceEl = $container.find('.price-item--sale .money').first();
        if (!$priceEl.length) $priceEl = $container.find('.money').first();
        if ($priceEl.length) $priceEl.text(newPrice);

        var $compareEl = $container.find('del .money').first();
        if (!$compareEl.length) $compareEl = $container.find('.price-item--regular .money').first();
        if ($compareEl.length) {
          if (newCompareAt && variant.compare_at_price > variant.price) {
            $compareEl.text(newCompareAt);
            $compareEl.closest('del').removeAttr('hidden');
          } else {
            $compareEl.closest('del').attr('hidden', '');
          }
        }

        $container.removeClass('visibility-hidden');
      });
    }
    // ── updateUrlVariant ──────────────────────────────────────────────────────
    function updateUrlVariant(variantId) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({ variantId: variantId }, '', url.toString());
    }
  });

}(jQuery));